import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchUsers = createAsyncThunk('users/fetch', async (params = {}) => {
  const { page = 1, limit = 50, search = '', role = '', isActive = '' } = params;
  const response = await api.get('/users', {
    params: { page, limit, search, role, isActive }
  });
  return response.data;
});

export const createUser = createAsyncThunk('users/create', async (data) => {
  const response = await api.post('/users', data);
  return response.data;
});

export const updateUser = createAsyncThunk('users/update', async ({ id, data }) => {
  const response = await api.put(`/users/${id}`, data);
  return response.data;
});

const userSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 50,
      totalPages: 0
    },
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        console.log('fetchUsers response:', action.payload);
        state.items = action.payload.users || [];
        state.pagination = action.payload.pagination || {
          total: 0,
          page: 1,
          limit: 50,
          totalPages: 0
        };
        state.loading = false;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const index = state.items.findIndex(u => u.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      });
  }
});

export default userSlice.reducer;
